export const CategoriesLabels = {
  LOGS: {
    categoryTitle: 'Logs',
    READ_LOGS: {
      permissionTitle: 'Read logs',
      key: 'READ',
    },
  },
  USERS: {
    categoryTitle: 'Customers',
    READ_USERS: {
      permissionTitle: 'Read customers',
      key: 'READ',
    },

    UPDATE_WALLET: {
      permissionTitle: 'Sync wallet',
      key: 'UPDATE_WALLET',
    },

    UPDATE_USERS: {
      permissionTitle: 'Update customers',
      key: 'UPDATE',
    },
  },
  // FILES: {
  //   categoryTitle: 'Files',
  //   READ_FILES: {
  //     permissionTitle: 'Read files',
  //     key: 'READ',
  //   },
  //   DELETE_FILES: {
  //     permissionTitle: 'Delete files',
  //     key: 'DELETE',
  //   },
  //   UPDATE_FILES: {
  //     permissionTitle: 'Update files',
  //     key: 'UPDATE',
  //   },
  // },
  ROLES: {
    categoryTitle: 'Roles',
    READ_ROLES: {
      permissionTitle: 'Read roles',
      key: 'READ',
    },
    DELETE_ROLES: {
      permissionTitle: 'Delete roles',
      key: 'DELETE',
    },
    UPDATE_ROLES: {
      permissionTitle: 'Update roles',
      key: 'UPDATE',
    },
    CREATE_ROLES: {
      permissionTitle: 'Create roles',
      key: 'CREATE',
    },
  },
  FLIERS: {
    categoryTitle: 'Flyers',
    READ_FLIERS: {
      permissionTitle: 'Read flyers',
      key: 'READ',
    },
    DELETE_FLIERS: {
      permissionTitle: 'Delete flyers',
    },
    UPDATE_FLIERS: {
      permissionTitle: 'Update flyers',
    },
    CREATE_FLIERS: {
      permissionTitle: 'Create flyers',
    },
  },
  RATING: {
    categoryTitle: 'Rating',
    READ_RATING: {
      permissionTitle: 'Read rating',
    },
    // DELETE_RATING: {
    //   permissionTitle: 'Delete rating',
    // },
    UPDATE_RATING: {
      permissionTitle: 'Update rating',
    },
    // CREATE_RATING: {
    //   permissionTitle: 'Create rating',
    // },
  },
  ORDERS: {
    categoryTitle: 'Orders',
    READ_ORDERS: {
      permissionTitle: 'Read orders',
    },
    SEND_ORDERS: {
      permissionTitle: 'Send orders',
    },
    // UPDATE_ORDERS: {
    //   permissionTitle: 'Update orders',
    // },
  },
  OFFERS: {
    categoryTitle: 'Offers',
    READ_OFFERS: {
      permissionTitle: 'Read offers',
    },
    CREATE_OFFERS: {
      permissionTitle: 'Create offers',
    },
    UPDATE_OFFERS: {
      permissionTitle: 'Update offers',
    },
  },
  COUPONS: {
    categoryTitle: 'Coupons',
    READ_COUPONS: {
      permissionTitle: 'Read coupons',
    },
    DELETE_COUPONS: {
      permissionTitle: 'Delete coupons',
    },
    // UPDATE_COUPONS: {
    //   permissionTitle: 'Update coupons',
    // },
    CREATE_COUPONS: {
      permissionTitle: 'Create coupons',
    },
  },
  MOSQUES: {
    categoryTitle: 'Mosques',
    READ_MOSQUES: {
      permissionTitle: 'Read mosques',
    },
    UPDATE_MOSQUES: {
      permissionTitle: 'Update mosques',
    },
  },
  MOSQUE_REQUESTS: {
    categoryTitle: 'Mosque Requests',
    READ_MOSQUE_REQUESTS: {
      permissionTitle: 'Read mosque requests',
      key: 'READ',
    },
  },
  PRODUCTS: {
    categoryTitle: 'Products',
    READ_PRODUCTS: {
      permissionTitle: 'Read products',
    },
    UPDATE_PRODUCTS: {
      permissionTitle: 'Update products',
    },
  },
  UPSELLING: {
    categoryTitle: 'Upseling',
    READ_UPSELLING: {
      permissionTitle: 'Read upselling',
    },
    UPDATE_UPSELLING: {
      permissionTitle: 'Update upselling',
    },
  },
  DASHBOARD: {
    categoryTitle: 'Dashboard',
    READ_DASHBOARD: {
      permissionTitle: 'Read dashboard',
    },
  },
  PROMOTIONS: {
    categoryTitle: 'Promotions',
    READ_PROMOTIONS: {
      permissionTitle: 'Read promotions',
    },
    UPDATE_PROMOTIONS: {
      permissionTitle: 'Update promotions',
    },
  },
  PROMO: {
    categoryTitle: 'Promo codes',
    READ_PROMO_CODES: {
      permissionTitle: 'Read promo codes',
    },
    DELETE_PROMO_CODES: {
      permissionTitle: 'Delete promo codes',
    },
    UPDATE_PROMO_CODES: {
      permissionTitle: 'Update promo codes',
    },
    CREATE_PROMO_CODES: {
      permissionTitle: 'Create promo codes',
    },
  },
  NOTIFICATIONS: {
    categoryTitle: 'Notifications',
    READ_NOTIFICATIONS: {
      permissionTitle: 'Read notifications',
    },
    SEND_NOTIFICATIONS: {
      permissionTitle: 'Send notifications',
    },
    DELETE_NOTIFICATIONS: {
      permissionTitle: 'Delete notifications',
    },
    UPDATE_NOTIFICATIONS: {
      permissionTitle: 'Update notifications',
    },
    CREATE_NOTIFICATIONS: {
      permissionTitle: 'Create notifications',
    },
  },
  PRODUCT: {
    categoryTitle: 'Product categories',
    READ_PRODUCT_CATEGORIES: {
      permissionTitle: 'Read product categories',
    },
    UPDATE_PRODUCT_CATEGORIES: {
      permissionTitle: 'Update product categories',
    },
  },
  ADMIN: {
    categoryTitle: 'Admin users',
    READ_ADMIN_USERS: {
      permissionTitle: 'Read admin users',
    },
    // DELETE_ADMIN_USERS: {
    //   permissionTitle: 'Delete admin users',
    // },
    CREATE_ADMIN_USERS: {
      permissionTitle: 'Create admin users',
    },
    DEACTIVATE_USER: {
      permissionTitle: 'Deactivate admin users',
    },
  },
  CAMPAIGN: {
    categoryTitle: 'Campaigns',
  },
  CONFIGURATIONS: {
    categoryTitle: 'Configurations',
    READ_CONFIGURATIONS: {
      permissionTitle: 'Read configurations',
      key: 'READ',
    },
    CREATE_CONFIGURATIONS: {
      permissionTitle: 'Create configurations',
      key: 'CREATE',
    },
    UPDATE_CONFIGURATIONS: {
      permissionTitle: 'Update configurations',
      key: 'UPDATE',
    },
    DELETE_CONFIGURATIONS: {
      permissionTitle: 'Delete configurations',
      key: 'DELETE',
    },
  },
  TERMS_CONDITIONS: {
    categoryTitle: 'Terms & Conditions',
    READ_TERMS_CONDITIONS: {
      permissionTitle: 'Read terms and conditions',
      key: 'READ',
    },
    CREATE_TERMS_CONDITIONS: {
      permissionTitle: 'Create terms and conditions',
      key: 'CREATE',
    },
    UPDATE_TERMS_CONDITIONS: {
      permissionTitle: 'Update terms and conditions',
      key: 'UPDATE',
    },
    DELETE_TERMS_CONDITIONS: {
      permissionTitle: 'Delete terms and conditions',
      key: 'DELETE',
    },
  },
  FAQ: {
    categoryTitle: 'FAQ',
    READ_FAQ: {
      permissionTitle: 'Read FAQ',
      key: 'READ',
    },
    CREATE_FAQ: {
      permissionTitle: 'Create FAQ',
      key: 'CREATE',
    },
    UPDATE_FAQ: {
      permissionTitle: 'Update FAQ',
      key: 'UPDATE',
    },
    DELETE_FAQ: {
      permissionTitle: 'Delete FAQ',
      key: 'DELETE',
    },
  },
  BOOKLETS: {
    categoryTitle: 'E-Booklets',
    READ_BOOKLETS: {
      permissionTitle: 'Read booklets',
      key: 'READ',
    },
    CREATE_BOOKLETS: {
      permissionTitle: 'Create booklets',
      key: 'CREATE',
    },
    UPDATE_BOOKLETS: {
      permissionTitle: 'Update booklets',
      key: 'UPDATE',
    },
    // DELETE_BOOKLETS: {
    //   permissionTitle: 'Delete booklets',
    //   key: 'DELETE',
    // },
  },
  ADVERTISEMENTS: {
    categoryTitle: 'Banners',
    READ_ADVERTISEMENTS: {
      permissionTitle: 'Read Banners',
      key: 'READ',
    },
    CREATE_ADVERTISEMENTS: {
      permissionTitle: 'Create Banners',
      key: 'CREATE',
    },
    UPDATE_ADVERTISEMENTS: {
      permissionTitle: 'Update Banners',
      key: 'UPDATE',
    },
    DELETE_ADVERTISEMENTS: {
      permissionTitle: 'Delete Banners',
      key: 'DELETE',
    },
  },
  SUBSCRIPTIONS: {
    categoryTitle: 'Subscriptions',
    READ_SUBSCRIPTIONS: {
      permissionTitle: 'Read subscriptions',
      key: 'READ',
    },
    CREATE_SUBSCRIPTIONS: {
      permissionTitle: 'Create subscriptions',
      key: 'CREATE',
    },
    UPDATE_SUBSCRIPTIONS: {
      permissionTitle: 'Update subscriptions',
      key: 'UPDATE',
    },
    DELETE_SUBSCRIPTIONS: {
      permissionTitle: 'Delete subscriptions',
      key: 'DELETE',
    },
  },
  SUBSCRIPTION_PLANS: {
    categoryTitle: 'Subscription Plans',
    READ_SUBSCRIPTION_PLANS: {
      permissionTitle: 'Read subscription plans',
      key: 'READ',
    },
    CREATE_SUBSCRIPTION_PLANS: {
      permissionTitle: 'Create subscription plans',
      key: 'CREATE',
    },
    UPDATE_SUBSCRIPTION_PLANS: {
      permissionTitle: 'Update subscription plans',
      key: 'UPDATE',
    },
    DELETE_SUBSCRIPTION_PLANS: {
      permissionTitle: 'Delete subscription plans',
      key: 'DELETE',
    },
  },
}
//   min 1 max 30
// check all existing roles

export const CategoriesForAllLabels = {
  LOGS: {
    // categoryTitle: 'Logs',
    permissions: [
      {
        permissionTitle: 'Read logs',
        key: 'READ',
        fullKey: 'READ_LOGS',
      },
    ],
  },
  USERS: {
    // categoryTitle: 'Users',
    permissions: [
      {
        permissionTitle: 'Read customers',
        key: 'READ',
        fullKey: 'READ_USERS',
      },
      {
        permissionTitle: 'Sync wallet',
        key: 'UPDATE_WALLET',
        fullKey: 'UPDATE_WALLET',
      },
      {
        permissionTitle: 'Update customers',
        key: 'UPDATE',
        fullKey: 'UPDATE_USERS',
      },
    ],
  },
  // FILES: {
  //   // categoryTitle: 'Files',
  //   permissions: [
  //     {
  //       permissionTitle: 'Read files',
  //       key: 'READ',
  //       fullKey: 'READ_FILES',
  //     },
  //     {
  //       permissionTitle: 'Delete files',
  //       key: 'DELETE',
  //       fullKey: 'DELETE_FILES',
  //     },
  //     {
  //       permissionTitle: 'Update files',
  //       key: 'UPDATE',
  //       fullKey: 'UPDATE_FILES',
  //     },
  //   ],
  // },
  ROLES: {
    // categoryTitle: 'Roles',
    permissions: [
      {
        permissionTitle: 'Read roles',
        key: 'READ',
        fullKey: 'READ_ROLES',
      },
      {
        permissionTitle: 'Delete roles',
        key: 'DELETE',
        fullKey: 'DELETE_ROLES',
      },
      {
        permissionTitle: 'Update roles',
        key: 'UPDATE',
        fullKey: 'UPDATE_ROLES',
      },
      {
        permissionTitle: 'Create roles',
        key: 'CREATE',
        fullKey: 'CREATE_ROLES',
      },
    ],
  },
  FLIERS: {
    // categoryTitle: 'Fliers',
    permissions: [
      {
        permissionTitle: 'Read fliers',
        key: 'READ',
        fullKey: 'READ_FLIERS',
      },
      {
        permissionTitle: 'Delete fliers',
        key: 'DELETE',
        fullKey: 'DELETE_FLIERS',
      },
      {
        permissionTitle: 'Update filers',
        key: 'UPDATE',
        fullKey: 'UPDATE_FLIERS',
      },
      {
        permissionTitle: 'Create fliers',
        key: 'CREATE',
        fullKey: 'CREATE_FLIERS',
      },
    ],
  },
  RATING: {
    // categoryTitle: 'Rating',
    permissions: [
      {
        permissionTitle: 'Read rating',
        key: 'READ',
        fullKey: 'READ_RATING',
      },
      // {
      //   permissionTitle: 'Delete rating',
      //   key: 'DELETE',
      //   fullKey: 'DELETE_RATING',
      // },
      {
        permissionTitle: 'Update rating',
        key: 'UPDATE',
        fullKey: 'UPDATE_RATING',
      },
      // {
      //   permissionTitle: 'Create rating',
      //   key: 'CREATE',
      //   fullKey: 'CREATE_RATING',
      // },
    ],
  },
  ORDERS: {
    // categoryTitle: 'Orders',
    permissions: [
      {
        permissionTitle: 'Read orders',
        key: 'READ',
        fullKey: 'READ_ORDERS',
      },
      {
        permissionTitle: 'Send orders',
        key: 'SEND',
        fullKey: 'SEND_ORDERS',
      },
      // {
      //   permissionTitle: 'Update orders',
      //   key: 'UPDATE',
      //   fullKey: 'UPDATE_ORDERS',
      // },
    ],
  },
  OFFERS: {
    // categoryTitle: 'Offers',
    permissions: [
      {
        permissionTitle: 'Read offers',
        key: 'READ',
        fullKey: 'READ_OFFERS',
      },
      {
        permissionTitle: 'Create offers',
        key: 'CREATE',
        fullKey: 'CREATE_OFFERS',
      },
      {
        permissionTitle: 'Update offers',
        key: 'UPDATE',
        fullKey: 'UPDATE_OFFERS',
      },
    ],
  },
  COUPONS: {
    // categoryTitle: 'Coupons',
    permissions: [
      {
        permissionTitle: 'Read coupons',
        key: 'READ',
        fullKey: 'READ_COUPONS',
      },
      {
        permissionTitle: 'Delete coupons',
        key: 'DELETE',
        fullKey: 'DELETE_COUPONS',
      },
      // {
      //   permissionTitle: 'Update coupons',
      //   key: 'UPDATE',
      //   fullKey: 'UPDATE_COUPONS',
      // },
      {
        permissionTitle: 'Create coupons',
        key: 'CREATE',
        fullKey: 'CREATE_COUPONS',
      },
    ],
  },
  MOSQUES: {
    // categoryTitle: 'Mosques',
    permissions: [
      {
        permissionTitle: 'Read mosques',
        key: 'READ',
        fullKey: 'READ_MOSQUES',
      },
      {
        permissionTitle: 'Update mosques',
        key: 'UPDATE',
        fullKey: 'UPDATE_MOSQUES',
      },
    ],
  },
  MOSQUE_REQUESTS: {
    categoryTitle: 'Mosque Requests',
    permissions: [
      {
        permissionTitle: 'Read mosque requests',
        key: 'READ',
        fullKey: 'READ_MOSQUE_REQUESTS',
      },
      {
        permissionTitle: 'Update mosque requests',
        key: 'UPDATE',
        fullKey: 'UPDATE_MOSQUE_REQUESTS',
      },
    ],
  },
  PRODUCTS: {
    // categoryTitle: 'Products',
    permissions: [
      {
        permissionTitle: 'Read products',
        key: 'READ',
        fullKey: 'READ_PRODUCTS',
      },
      {
        permissionTitle: 'Update products',
        key: 'UPDATE',
        fullKey: 'UPDATE_PRODUCTS',
      },
    ],
  },
  UPSELLING: {
    // categoryTitle: 'Upseling',
    permissions: [
      {
        permissionTitle: 'Read upselling',
        key: 'READ',
        fullKey: 'READ_UPSELLING',
      },
      {
        permissionTitle: 'Update upselling',
        key: 'UPDATE',
        fullKey: 'UPDATE_UPSELLING',
      },
    ],
  },
  DASHBOARD: {
    // categoryTitle: 'Dashboard',
    permissions: [
      {
        permissionTitle: 'Read dashboard',
        key: 'READ',
        fullKey: 'READ_DASHBOARD',
      },
    ],
  },
  PROMOTIONS: {
    // categoryTitle: 'Promotions',
    permissions: [
      {
        permissionTitle: 'Read promotions',
        key: 'READ',
        fullKey: 'READ_PROMOTIONS',
      },
      {
        permissionTitle: 'Update promotions',
        key: 'UPDATE',
        fullKey: 'UPDATE_PROMOTIONS',
      },
    ],
  },
  PROMO: {
    // categoryTitle: 'Promo codes',
    permissions: [
      {
        permissionTitle: 'Read promo codes',
        key: 'READ',
        fullKey: 'READ_PROMO_CODES',
      },
      {
        permissionTitle: 'Delete promo codes',
        key: 'DELETE',
        fullKey: 'DELETE_PROMO_CODES',
      },
      {
        permissionTitle: 'Update promo codes',
        key: 'UPDATE',
        fullKey: 'UPDATE_PROMO_CODES',
      },
      {
        permissionTitle: 'Create promo codes',
        key: 'CREATE',
        fullKey: 'CREATE_PROMO_CODES',
      },
    ],
  },
  NOTIFICATIONS: {
    // categoryTitle: 'Notifications',
    permissions: [
      {
        permissionTitle: 'Read notifications',
        key: 'READ',
        fullKey: 'READ_NOTIFICATIONS',
      },
      {
        permissionTitle: 'Send notifications',
        key: 'SEND',
        fullKey: 'SEND_NOTIFICATIONS',
      },
      {
        permissionTitle: 'Delete notifications',
        key: 'DELETE',
        fullKey: 'DELETE_NOTIFICATIONS',
      },
      {
        permissionTitle: 'Update notifications',
        key: 'UPDATE',
        fullKey: 'UPDATE_NOTIFICATIONS',
      },
      {
        permissionTitle: 'Create notifications',
        key: 'CREATE',
        fullKey: 'CREATE_NOTIFICATIONS',
      },
    ],
  },
  PRODUCT: {
    // categoryTitle: 'Product categories',
    permissions: [
      {
        permissionTitle: 'Read product categories',
        key: 'READ',
        fullKey: 'READ_PRODUCT_CATEGORIES',
      },
      {
        permissionTitle: 'Update product categories',
        key: 'UPDATE',
        fullKey: 'UPDATE_PRODUCT_CATEGORIES',
      },
    ],
  },
  ADMIN: {
    // categoryTitle: 'Admin users',
    permissions: [
      {
        permissionTitle: 'Read admin users',
        key: 'READ',
        fullKey: 'READ_ADMIN_USERS',
      },
      // {
      //   permissionTitle: 'Delete admin users',
      //   key: 'DELETE',
      //   fullKey: 'DELETE_ADMIN_USERS',
      // },
      {
        permissionTitle: 'Create admin users',
        key: 'CREATE',
        fullKey: 'CREATE_ADMIN_USERS',
      },
      {
        permissionTitle: 'Update admin users',
        key: 'UPDATE',
        fullKey: 'UPDATE_ADMIN_USERS',
      },
      {
        permissionTitle: 'Update admin users',
        key: 'DEACTIVATE',
        fullKey: 'DEACTIVATE_USER',
      },
    ],
  },
  CAMPAIGN: {
    permissions: [
      {
        permissionTitle: 'Read campaign',
        key: 'READ',
        fullKey: 'READ_CAMPAIGN',
      },
      {
        permissionTitle: 'Create campaign',
        key: 'CREATE',
        fullKey: 'CREATE_CAMPAIGN',
      },
      {
        permissionTitle: 'Update campaign',
        key: 'UPDATE',
        fullKey: 'UPDATE_CAMPAIGN',
      },
      {
        permissionTitle: 'Delete campaign',
        key: 'DELETE',
        fullKey: 'DELETE_CAMPAIGN',
      },
    ],
  },
  CONFIGURATIONS: {
    permissions: [
      {
        permissionTitle: 'Read configurations',
        key: 'READ',
        fullKey: 'READ_CONFIGURATIONS',
      },
      // {
      //   permissionTitle: 'Create configurations',
      //   key: 'CREATE',
      //   fullKey: 'CREATE_CONFIGURATIONS',
      // },
      {
        permissionTitle: 'Update configurations',
        key: 'UPDATE',
        fullKey: 'UPDATE_CONFIGURATIONS',
      },
      // {
      //   permissionTitle: 'Delete configurations',
      //   key: 'DELETE',
      //   fullKey: 'DELETE_CONFIGURATIONS',
      // },
    ],
  },
  TERMS_CONDITIONS: {
    permissions: [
      {
        permissionTitle: 'Read terms and conditions',
        key: 'READ',
        fullKey: 'READ_TERMS_CONDITIONS',
      },
      {
        permissionTitle: 'Create terms and conditions',
        key: 'CREATE',
        fullKey: 'CREATE_TERMS_CONDITIONS',
      },
      {
        permissionTitle: 'Update terms and conditions',
        key: 'UPDATE',
        fullKey: 'UPDATE_TERMS_CONDITIONS',
      },
      {
        permissionTitle: 'Delete terms and conditions',
        key: 'DELETE',
        fullKey: 'DELETE_TERMS_CONDITIONS',
      },
    ],
  },
  FAQ: {
    permissions: [
      {
        permissionTitle: 'Read FAQ',
        key: 'READ',
        fullKey: 'READ_FAQ',
      },
      {
        permissionTitle: 'Create FAQ',
        key: 'CREATE',
        fullKey: 'CREATE_FAQ',
      },
      {
        permissionTitle: 'Update FAQ',
        key: 'UPDATE',
        fullKey: 'UPDATE_FAQ',
      },
      {
        permissionTitle: 'Delete FAQ',
        key: 'DELETE',
        fullKey: 'DELETE_FAQ',
      },
    ],
  },
  BOOKLETS: {
    permissions: [
      {
        permissionTitle: 'Read booklets',
        key: 'READ',
        fullKey: 'READ_BOOKLETS',
      },
      {
        permissionTitle: 'Create booklets',
        key: 'CREATE',
        fullKey: 'CREATE_BOOKLETS',
      },
      {
        permissionTitle: 'Update booklets',
        key: 'UPDATE',
        fullKey: 'UPDATE_BOOKLETS',
      },
      // {
      //   permissionTitle: 'Delete booklets',
      //   key: 'DELETE',
      //   fullKey: 'DELETE_BOOKLETS',
      // },
    ],
  },
  ADVERTISEMENTS: {
    permissions: [
      {
        permissionTitle: 'Read Banners',
        key: 'READ',
        fullKey: 'READ_ADVERTISEMENTS',
      },
      {
        permissionTitle: 'Create Banners',
        key: 'CREATE',
        fullKey: 'CREATE_ADVERTISEMENTS',
      },
      {
        permissionTitle: 'Update Banners',
        key: 'UPDATE',
        fullKey: 'UPDATE_ADVERTISEMENTS',
      },
      {
        permissionTitle: 'Delete Banners',
        key: 'DELETE',
        fullKey: 'DELETE_ADVERTISEMENTS',
      },
    ],
  },
  SUBSCRIPTIONS: {
    permissions: [
      {
        permissionTitle: 'Read subscriptions',
        key: 'READ',
        fullKey: 'READ_SUBSCRIPTIONS',
      },
      {
        permissionTitle: 'Create subscriptions',
        key: 'CREATE',
        fullKey: 'CREATE_SUBSCRIPTIONS',
      },
      {
        permissionTitle: 'Update subscriptions',
        key: 'UPDATE',
        fullKey: 'UPDATE_SUBSCRIPTIONS',
      },
      {
        permissionTitle: 'Delete subscriptions',
        key: 'DELETE',
        fullKey: 'DELETE_SUBSCRIPTIONS',
      },
    ],
  },
  SUBSCRIPTION_PLANS: {
    permissions: [
      {
        permissionTitle: 'Read subscription plans',
        key: 'READ',
        fullKey: 'READ_SUBSCRIPTION_PLANS',
      },
      {
        permissionTitle: 'Create subscription plans',
        key: 'CREATE',
        fullKey: 'CREATE_SUBSCRIPTION_PLANS',
      },
      {
        permissionTitle: 'Update subscription plans',
        key: 'UPDATE',
        fullKey: 'UPDATE_SUBSCRIPTION_PLANS',
      },
      {
        permissionTitle: 'Delete subscription plans',
        key: 'DELETE',
        fullKey: 'DELETE_SUBSCRIPTION_PLANS',
      },
    ],
  },
}
